import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-timeline-vertical',
  templateUrl: './timeline-vertical.component.html',
  styleUrls: ['./timeline-vertical.component.css']
})
export class TimelineVerticalComponent implements OnInit {

  @Input() sectionInfo;
  
  constructor() { }

  ngOnInit(): void {
  }

}
